module.exports = __webpack_public_path__ + "img/80.11abdc79.jpg";